import React, { Fragment, useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { FaPlus } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import TnsbDropdown from "./TnsbDropdown"
import { haveAuth } from "utils"
import { fetchSmsBalance } from "@redux"
import { Tooltip } from "components"
import TnsbTopupModal from "./TnsbTopupModal"
import classes from "./index.module.scss"

const TnSmsBalance = () => {
  const dispatch = useDispatch()

  const [t] = useTranslation()

  const smsBalance =
    useSelector(state => state.smsBalance)

  const userBranches =
    useSelector(state => state.userAccountInfo.userBranches)

  const [selectedBranch, setSelectedBranch] = useState(null)
  const [openTopupModal, setOpenTopupModal] = useState(false)

  const getSmsBalance = async () => {
    if (selectedBranch === null) return

    dispatch(
      fetchSmsBalance(selectedBranch._id)
    )
  }

  const getInitialBranch = () => {
    if (!userBranches?.[0]) return

    if (selectedBranch !== null) return

    const selectedBranchId =
      localStorage.getItem("sbid")

    const initialBranch =
      userBranches.find(ub => ub._id === selectedBranchId)
      || userBranches[0]

    setSelectedBranch(initialBranch)
  }

  useEffect(() => {
    getInitialBranch()
  }, [userBranches])

  useEffect(() => {
    getSmsBalance()
  }, [selectedBranch])

  const hideSmsBalance =
    smsBalance === null ||
    selectedBranch === null ||
    !haveAuth(["viewSmsBalance"])

  if (hideSmsBalance) return null

  return (
    <Fragment>
      <div className={classes["row"]}>
        <div className={classes["wallet"]}>
          {t("باقیمانده_پیامک_ها")}
          <TnsbDropdown
            selectedBranch={selectedBranch}
            setSelectedBranch={setSelectedBranch}
          />
          :
          <b className={classes["number"]}>
            {t("smsBalance_عدد", { smsBalance })}
          </b>
        </div>

        {
          haveAuth(["smsBalanceTopup"]) &&
          <Tooltip title={t("افزایش_موجودی")}>
            <button
              onClick={() => setOpenTopupModal(true)}
              className={classes["button"]}
            >
              <FaPlus />
            </button>
          </Tooltip>
        }
      </div>

      <TnsbTopupModal
        selectedBranch={selectedBranch}
        openTopupModal={openTopupModal}
        setOpenTopupModal={setOpenTopupModal}
      />
    </Fragment>
  )
}

export default TnSmsBalance